import React, {useEffect} from 'react'
import Header from '../../Header';
import "../../styles/theme.scss"
import {useTranslation} from 'react-i18next';
import {styled} from "@mui/material/styles";
import {Grid} from "@mui/material";
import ClaimForm from '../../components/Claim/ClaimForm';
import {fetchHealthFacilities, loadingUser} from '../../action';
import {useDispatch, useSelector} from "react-redux";

const Content = styled("div")(({ theme }) => ({
  flexGrow: 1,
  paddingRight: theme.jrnlDrawer.close.width - theme.spacing(1),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // Add margin top here
  // marginTop: theme.spacing(10), // Adjust the spacing as needed
}));

function ClaimFormPage() {
  const token = localStorage.getItem("token");

  const userData = useSelector((state) => state.profileReducer.currentUserResponseData);

  const dispatch = useDispatch();
  const navigate = (path) => {
    // Your custom navigation logic here
    // console.log("Navigating to:", path);
    // For example, you might use window.location.href to change the URL
    window.location.href = path;
  };
  const handleNavigation = (path) => {
    navigate(path);
  };
  const { t } = useTranslation();

  useEffect(() => {
    if (token) {
      dispatch(loadingUser(token));
    }
  }, [token, dispatch])

  useEffect(() => {
    if (userData) {
      dispatch(fetchHealthFacilities(userData.i_user?.health_facility_id))
    }
  }, [userData, dispatch])

  return (
    <Grid >
      <Header
        navigate={handleNavigation}
        children={
          <Content>
            <ClaimForm />
          </Content>
        }
      />
    </Grid>
  );
}

export default ClaimFormPage;
